// this Object's name is MediathekUrlSearchParams to not confuse it
// with https://developer.mozilla.org/de/docs/Web/API/URLSearchParams
export default {
  asset: 'asset'
};
